
import React from "react"
import { useState } from 'react';
import H2HItem from '../H2HItem';
import HeaderTopRecentMatches from "@/components/HeaderTopRecentMatches";

function TabPanel({ home, away, data }) {
  const [activeTab, setActiveTab] = useState('first');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  data.sort((a, b) => parseInt(b.matchTime) - parseInt(a.matchTime));

  return (
    <div className="rounded w-full mx-auto">
      <ul id="tabs" className="inline-flex mt-2 w-full mb-2">
        <li
          className={`px-[8px] mr-[10px] font-semibold py-[4px] flex rounded-[100px] justify-center flex ${
            activeTab === 'first' ? 'bg-[var(--theme-primary)] text-[var(--foreground)] -mb-px' : ''
          }`}
        >
          <button className={`${activeTab === 'first' ? 'bg-transparent border-none text-sm text-[var(--theme-on-primary)]' : 'rounded-full'}`} onClick={() => handleTabClick('first')}>Tất cả</button>
        </li>
        <li
          className={`px-[8px] mr-[10px] font-semibold py-[4px] flex rounded-[100px] justify-center flex ${
            activeTab === 'second' ? 'bg-[var(--theme-primary)] text-[var(--foreground)] -mb-px' : ''
          }`}
        >
          <button className={`${activeTab === 'second' ? 'bg-transparent border-none text-sm text-[var(--theme-on-primary)]' : 'rounded-full'}`} onClick={() => handleTabClick('second')}>{`${home.name} sân nhà`}</button>
        </li>
        <li
          className={`px-[8px] font-semibold py-[4px] flex rounded-[100px] justify-center flex ${
            activeTab === 'third' ? 'bg-[var(--theme-primary)] text-[var(--foreground)] -mb-px' : ''
          }`}
        >
          <button className={`${activeTab === 'third' ? 'bg-transparent border-none text-sm text-[var(--theme-on-primary)]' : 'rounded-full'}`} onClick={() => handleTabClick('third')}>{`${away.name} sân nhà`}</button>
        </li>
      </ul>

      <div id="tab-contents">
        <HeaderTopRecentMatches/>
        <div className={`${activeTab === 'first' ? '' : 'hidden'}`}>
          {data.map((item, index) => <H2HItem key={index} match={item} />)}
        </div>
        <div className={`${activeTab === 'second' ? '' : 'hidden'}`}>
        {data.filter((e) => e.homeTeamId === home.id).map((item, index) => <H2HItem key={index} match={item} />)}
          
        </div>
        <div className={`${activeTab === 'third' ? '' : 'hidden'}`}>
          {data.filter((e) => e.homeTeamId === away.id).map((item, index) => <H2HItem key={index} match={item} />)}
        </div>
      </div>
    </div>
  );
}

export default React.memo(TabPanel);
